import { render, staticRenderFns } from "./ChangeUserCompanyDialog.vue?vue&type=template&id=1626119f"
import script from "./ChangeUserCompanyDialog.vue?vue&type=script&lang=js"
export * from "./ChangeUserCompanyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports